import { render, staticRenderFns } from "./open.vue?vue&type=template&id=53f1a1c8&scoped=true"
import script from "./open.vue?vue&type=script&lang=js"
export * from "./open.vue?vue&type=script&lang=js"
import style0 from "./open.vue?vue&type=style&index=0&id=53f1a1c8&prod&lang=css"
import style1 from "./open.vue?vue&type=style&index=1&id=53f1a1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1a1c8",
  null
  
)

export default component.exports